"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const chooseLocationContext_1 = require("../chooseLocationContext");
const CountrySearch_1 = require("./CountrySearch");
const CountryMenu_1 = require("./CountryMenu");
const CountryComponent = () => {
    const [focusedElementIndex, setFocusedElementIndex] = React.useState(-1);
    const searchInputRef = React.useRef(null);
    const { state } = (0, chooseLocationContext_1.useChooseLocationContext)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CountrySearch_1.default, { setFocusedElementIndex: setFocusedElementIndex, searchInputRef: searchInputRef }), state.isCountryMenuOpened && ((0, jsx_runtime_1.jsx)(CountryMenu_1.default, { searchInputRef: searchInputRef, focusedElementIndex: focusedElementIndex, setFocusedElementIndex: setFocusedElementIndex }))] }));
};
exports.CountryComponent = CountryComponent;
exports.default = exports.CountryComponent;
